import firebase from 'firebase/app';
import 'firebase/firestore';
import 'tailwindcss/dist/base.min.css';

firebase.initializeApp({
  apiKey: 'AIzaSyCP8oWKwX6YiA9LXPnWmnnObOlNhz4OmB8',
  authDomain: 'wifilogger-api.firebaseapp.com',
  databaseURL: 'https://wifilogger-api.firebaseio.com',
  projectId: 'wifilogger-api',
  storageBucket: 'wifilogger-api.appspot.com',
  messagingSenderId: '442272046235',
  appId: '1:442272046235:web:2052d15bbb9dfd2be4ba3e',
});

// if (window.location.hostname === "localhost") {
//   firebase.firestore().settings({
//     host: "localhost:8080",
//     ssl: false,
//   })
// }

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
